/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreNasListAliases {
  ADD_SCORE_NAS_CUSTOM_DYNAMIC_BUTTON = 'add-score-nas-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_NAS = 'deck-score-nas',
  FETCH_SCORE_NAS_LIST = 'fetch-score-nas-list',
  FILTERED_LIST_SCORE_NAS = 'filtered-list-score-nas',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_NAS_LIST = 'layout-score-nas-list',
  LEGENDES_SCORE_NAS = 'legendes-score-nas',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_NAS = 'scores-and-indexes-card-nas',
}
export { ScoreNasListAliases };
